// extracted by mini-css-extract-plugin
module.exports = {"chart":"Chart_chart__1WEGY","dragging":"Chart_dragging__3-ZtC","my-2":"Chart_my-2__1C8I1","mx-2":"Chart_mx-2__3Igej","chart-in-storage":"Chart_chart-in-storage__mNOoE"};